module.exports = __webpack_public_path__ + "img/IMG_6070_L_Wood_MockedUp.269e88cb.jpg";